export default {
  apiKey: "AIzaSyAp0h9pRsV9q28B_KRg9BElO3DHUjaT74I",
  authDomain: "emc-mdnacloud-poc03-t.firebaseapp.com",
  projectId: "emc-mdnacloud-poc03-t",
  storageBucket: "emc-mdnacloud-poc03-t.firebasestorage.app",
  messagingSenderId: "914157285540",
  appId: "1:914157285540:web:ba4ae908c5b96f0dda7631",
  databaseURL: "https://emc-mdnacloud-poc03-t.firebaseapp.com"
};
